import { container } from '../services/container'
import { User } from '../core/User'

export function UserProvider (next) {

	container.get('services.oauth').authenticate()

	.then(response => {
		container.set('user', new User(response.body.data.resource))
		window.user = container.get('user')
		if (window.user && window.user.source) {
			if (window.user.source != 'default') {
				container.get('source').updateValue(window.user.source);
			} else {
				container.get('source').updateValue(null)
			}
		}



		next()
	})

	.catch(_ => {
		console.log('An error has occurred while loading the user' + _)
		next()
	})
}